import type { FC } from 'react';
import { useFormContext } from 'react-hook-form-latest';

import FormField from '@/components/UI/FormFields/Latest/FormField';
import { getRegisterConfig } from '@/components/UI/FormFields/FormField.utils';

interface RadioOption {
  label: string;
  value: string;
}

interface RadioProps {
  options: Array<RadioOption>;
  name: string;
  label: string;
  disabled?: boolean;
  hint?: string;
  required?: boolean;
  testId?: string;
}

const Radio: FC<RadioProps> = ({ options, name, label, disabled = false, hint, required, testId = 'radio' }) => {
  const { register } = useFormContext();
  return (
    <FormField label={label} name={name} hint={hint} required={required} testPrefix={testId}>
      {options.map((option, i) => (
        <div className="flex items-center pb2" key={option.value}>
          <label htmlFor={`${name}_${i}`}>
            <input
              id={`${name}_${i}`}
              data-test-component="Radio"
              data-test-element="input"
              data-test-key={option.value}
              type="radio"
              value={option.value}
              className="pointer ui__form__radio"
              style={{ marginBottom: 0 }}
              disabled={disabled}
              data-testid={testId}
              {...register(name, getRegisterConfig({ required }))}
            />
            <span className="pointer pl3 v-top" style={{ marginBottom: 0 }}>
              {option.label}
            </span>
          </label>
        </div>
      ))}
    </FormField>
  );
};

export default Radio;
